import { render, staticRenderFns } from "./CarList.vue?vue&type=template&id=65ce985a&scoped=true&"
import script from "./CarList.vue?vue&type=script&lang=ts&"
export * from "./CarList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce985a",
  null
  
)

export default component.exports